/**
 * Link Content UseCase
 *
 * Links two of the current user's media items together.
 * Mirrors Flutter MediasRepository.linkContent
 * (lib/data/repository/medias_repository.dart:342).
 */

import { MediaService } from '@/domain/services/media/mediaService';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class LinkContentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(source: UserMediaEntity, destination: UserMediaEntity): Promise<boolean> {
    try {
      return await this.mediaService.linkContent(source, destination);
    } catch (error) {
      appLogger.error('Error linking content', 'LinkContentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const linkContentUseCase = new LinkContentUseCase();
